const tokenKey = (id: number) => `inscricao-token:${id}`;
const memoria = new Map<string, string>();
const reciboKey = (eventoId: unknown, email: unknown) =>
  `inscricao-recibo:${eventoId}:${String(email ?? "").trim().toLowerCase()}`;

function ler(key: string): string | null {
  try { return sessionStorage.getItem(key); } catch { return memoria.get(key) ?? null; }
}

function guardar(key: string, value: string): void {
  try { sessionStorage.setItem(key, value); } catch { memoria.set(key, value); }
}

export function guardarTokenInscricao(id: number, token: unknown): void {
  if (id > 0 && typeof token === "string" && token) guardar(tokenKey(id), token);
}

export function obterTokenInscricao(id: number): string | undefined {
  if (!id) return undefined;
  const idDaUrl = typeof window !== "undefined" && !/\/volunt(?:ario|ário)\//.test(window.location.pathname)
    ? Number(window.location.pathname.match(/\/(?:pagamento|inscricao-concluida)\/(\d+)\/?$/)?.[1])
    : 0;
  const daUrl = idDaUrl === id ? new URLSearchParams(window.location.search).get("t") : null;
  if (daUrl) {
    guardarTokenInscricao(id, daUrl);
    return daUrl;
  }
  return ler(tokenKey(id)) ?? undefined;
}

/** O token faz parte da chave do cache RTK: uma resposta mínima não substitui a completa. */
export function checkoutInscricaoQuery(id: number | null | undefined) {
  return { participanteId: Number(id) || 0, token: obterTokenInscricao(Number(id)) };
}

export function comTokenInscricao(path: string, id: number, token = obterTokenInscricao(id)): string {
  if (!token) return path;
  const [base, hash] = path.split("#");
  const [pathname, query] = base.split("?");
  const params = new URLSearchParams(query);
  params.set("t", token);
  return `${pathname}?${params.toString()}${hash ? `#${hash}` : ""}`;
}

export function guardarReciboInscricao(body: any, recibo: unknown): void {
  if (typeof recibo !== "string" || !recibo) return;
  for (const eventoId of [body.EventoId, ...(body.turmas ?? [])]) {
    guardar(reciboKey(eventoId, body.Email), recibo);
  }
}

export function obterReciboInscricao(eventoId: unknown, email: string): string | null {
  return ler(reciboKey(eventoId, email));
}

export function inscricaoPollingQuery(eventoId: number | string, email: string) {
  return { eventoId: Number(eventoId), email, recibo: obterReciboInscricao(eventoId, email) ?? undefined };
}

export function urlSemTokenInscricao(url: string): string {
  if (!url) return url;
  try {
    const parsed = new URL(url);
    if (!parsed.searchParams.has("t")) return url;
    parsed.searchParams.delete("t");
    return parsed.toString();
  } catch { return ""; }
}
